import computerClub from '@/assets/img/users-cases/computer-club.webp';
import computerClubHow from '@/assets/img/users-cases/computer-club-how.webp';
import computerClubResult from '@/assets/img/users-cases/computer-club-result.webp';

export default {
  slug: 'computer-club',
  order: 20,
  title: '360 Gaming Club Tour',
  subtitle: 'High-energy 3D visuals and walkthrough video tours',
  tags: ['CommercialLayouts', 'InteriorDesign'],

  images: {
    hero: computerClub,
    aboutTop: computerClubHow,
    aboutBottom: computerClubResult,
  },

  howText:
    'We developed 2D and 3D layouts and interior design solutions, laying out seating density, equipment placement, and visitor flow.',

  resultText:
    'The visuals help investors and operators size up the space and assess its commercial potential before launch.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
